import React from "react";
import "./AnushashanModal.css";
import images from "../../../../utilities/images/images";
// import badgeIcon from "../../assets/badge.svg";

const AnushashanModal = ({
  onClose,
  onStartTrial,
  popupDescription,
  popupTitle,
  setShowAnushashanModal,
}) => {
 
  return (
    <div className="modal-overlay">
      <div className="modal-container" >
        <button className="anushashan-close-btn" onClick={()=>onClose()}><div className="circle">
          × </div>
        </button>

        <div className="modal-top">
          <img
            src={images.SevenDays}
            alt="Free Trial Badge"
            className="badge-icon"
          />

          <div className="icon-wrapper">
            <img src={images.ansIcon} alt="class icon" />
          </div>
        </div>

        <div className="modal-content-anushashan">
          <h2>{popupTitle}</h2>
          <p>{popupDescription}</p>
          <button className="start-btn" onClick={onStartTrial}>
            Start Your Free Trial
          </button>
        </div>
      </div>
    </div>
  );
};

export default AnushashanModal;
